
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'searchFilter',
    pure: false
})

export class SearchFilter implements PipeTransform {
    public transform(value, keys: string, term: string) {
        if (!term) {
            return value;
        }
        return (value || []).filter((item) => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key])));
        }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/shared/searchFilter.pipe.ts